namespace GeniuzPOS.CustomReport {
    export interface ReportCusPromotionSaleForm {
        DateSale: Serenity.StringEditor;
        Category1: Serenity.StringEditor;
        Category2: Serenity.StringEditor;
        Category3: Serenity.StringEditor;
        NetSaleExVat: Serenity.DecimalEditor;
        PromoId: Serenity.StringEditor;
        PromoName: Serenity.StringEditor;
        PromoperiodFrom: Serenity.DateEditor;
        PromoperiodTo: Serenity.DateEditor;
        DateYear: Serenity.StringEditor;
        DateMonth: Serenity.StringEditor;
        SalesQty: Serenity.DecimalEditor;
        SkuCode: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        ItemName: Serenity.StringEditor;
        SupplierCode: Serenity.StringEditor;
        SupplierName: Serenity.StringEditor;
        OnHandQty: Serenity.DecimalEditor;
    }

    export class ReportCusPromotionSaleForm extends Serenity.PrefixedContext {
        static formKey = 'CustomReport.ReportCusPromotionSale';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportCusPromotionSaleForm.init)  {
                ReportCusPromotionSaleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.DateEditor;

                Q.initFormType(ReportCusPromotionSaleForm, [
                    'DateSale', w0,
                    'Category1', w0,
                    'Category2', w0,
                    'Category3', w0,
                    'NetSaleExVat', w1,
                    'PromoId', w0,
                    'PromoName', w0,
                    'PromoperiodFrom', w2,
                    'PromoperiodTo', w2,
                    'DateYear', w0,
                    'DateMonth', w0,
                    'SalesQty', w1,
                    'SkuCode', w0,
                    'PluCode', w0,
                    'ItemName', w0,
                    'SupplierCode', w0,
                    'SupplierName', w0,
                    'OnHandQty', w1
                ]);
            }
        }
    }
}
